export const getPropertyNavigationTabs = state => state.formPropertyNavigationTabs;
export const getActiveTab = state => getPropertyNavigationTabs(state).active;